
<cml-form></cml-form>

<cml-ucetni-obdobi (ucetniObdobiDataEvent)="ucetniObdobiLoaded($event)"></cml-ucetni-obdobi>

<cml-definice-vykazu (definiceJednotky)="definiceLoaded($event)"></cml-definice-vykazu>

<cml-extended-detail></cml-extended-detail>


